import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress
} from '@mui/material'
import PropTypes from 'prop-types'

const SmsTestDialog = ({
  open,
  onClose,
  automationName,
  onSendTest
}) => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [sending, setSending] = useState(false)
  const [result, setResult] = useState(null)

  const handleClose = () => {
    setPhoneNumber('')
    setSending(false)
    setResult(null)
    onClose()
  }

  const handleSend = async () => {
    setSending(true)
    setResult(null)
    const response = await onSendTest(phoneNumber)
    setResult(response)
    setSending(false)
  }

  const isValidPhone = phoneNumber.replace(/\D/g, '').length >= 10

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Test SMS - {automationName}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" paragraph>
          Send a test SMS using this automation&apos;s template with sample data.
        </Typography>

        <TextField
          fullWidth
          label="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="(555) 123-4567"
          margin="normal"
          helperText="US phone number - will be formatted to E.164"
        />

        {result && (
          <Box mt={2} p={2} bgcolor={result.success ? '#e8f5e9' : '#ffebee'} borderRadius={4}>
            <Typography
              variant="subtitle2"
              style={{ color: result.success ? '#2e7d32' : '#c62828' }}
            >
              {result.success ? 'SMS Sent Successfully' : 'SMS Failed'}
            </Typography>
            {result.sid && (
              <Typography variant="body2" style={{ marginTop: 4 }}>
                Twilio SID: {result.sid}
              </Typography>
            )}
            {result.error && (
              <Typography variant="body2" color="error" style={{ marginTop: 4 }}>
                Error: {result.error}
              </Typography>
            )}
            {result.message_preview && (
              <Box mt={1}>
                <Typography variant="caption" color="textSecondary">
                  Message sent:
                </Typography>
                <Typography variant="body2" style={{ fontStyle: 'italic', marginTop: 2 }}>
                  &ldquo;{result.message_preview}&rdquo;
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {result ? 'Close' : 'Cancel'}
        </Button>
        <Button
          onClick={handleSend}
          color="primary"
          variant="contained"
          disabled={!isValidPhone || sending}
          startIcon={sending ? <CircularProgress size={16} /> : null}
        >
          {sending ? 'Sending...' : 'Send Test SMS'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SmsTestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  automationName: PropTypes.string,
  onSendTest: PropTypes.func.isRequired
}

export default SmsTestDialog
